<div class="form">
  <div class="title">
    <p>Contact Information</p>
  </div>
  <div class="horizontal-separator"></div>
  <form [formGroup]="form()">
    <div class="f-row">
      <div class="f-group">
        <label>Email*</label>
        <input
          formControlName="email"
          placeholder="Enter your email address"
          class="f-control"
          type="text"
          [class.error]="
            form() &&
            form().get('email').touched &&
            form().get('email').invalid
          "
        />
      </div>
    </div>
    <div class="f-row">
      <div class="f-group">
        <label>First Name*</label>
        <input
          formControlName="firstName"
          placeholder="Enter first name"
          class="f-control"
          type="text"
          [class.error]="
            form() &&
            form().get('firstName').touched &&
            form().get('firstName').invalid
          "
        />
      </div>
      <div class="f-group">
        <label>Last Name*</label>
        <input
          formControlName="lastName"
          placeholder="Enter last name"
          class="f-control"
          type="text"
          [class.error]="
            form() &&
            form().get('lastName').touched &&
            form().get('lastName').invalid
          "
        />
      </div>
    </div>
  </form>
  @if (error()) {
    <div class="message error">
      {{ error() }}
    </div>
  }
</div>
